import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService, CommonService, ErrorHandlerService } from 'epay-library';
import { Router } from '@angular/router';


export enum SpecialError {
  WebsessionExist = 1,
  AccountHold = 2,
}

@Component({
  selector: 'epay-login-common',
  templateUrl: './epay-login-common.component.html',
})
export class EpayLoginCommonComponent implements OnInit {
  @Input() tokenurl = '';
  @Input() baseurl = '';
  @Input() sessionTimeout = '';
  @Input() clientId = '';

  usertype = '';
  gotToken = false;
  mustChangePassword = false;
  logindata: any;
  loginFrmGrp: any;
  username: any;
  password: any;
  isAccountOnHold = false;
  errorMessage = '';
  invalidLogin = false;
  closeResult = '';
  passwordHide = true;
  invalidLoginMessage = '';
  setupresult = '';
  sessionCreated = false;
  sessionExist = false;
  userType = '';

  constructor(
    private formbuilder: FormBuilder,
    private authService: AuthService,
    private commonService: CommonService,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.usertype = history.state.userType;
    this.loginFrmGrp = this.formbuilder.group({
      username: ['', Validators.required],
      password: ['', [Validators.required]],
    });
  }

  togglePasswordHide() {
    this.passwordHide = !this.passwordHide;
  }

  login() {
    sessionStorage.clear();
    const logincred = this.loginFrmGrp.value;
    logincred.password = logincred.password.trim();
    

    if (logincred.username && logincred.password) {
      this.authService
        .login(
          this.tokenurl,
          logincred.username,
          logincred.password.replace("+", "%2B"),
          this.clientId
        )
        .subscribe({
          next: (results: any) => {
            this.logindata = results;
            this.authService.currentUserType.subscribe(
              (type: any) => (this.userType = type)
            );
            this.authService
              .insertWebSession(this.baseurl, this.sessionTimeout)
              .subscribe(
                (session: any) => {
                  if (session.responseStatus > 0) {
                    this.sessionExist = true;
                    this.handleError(SpecialError.WebsessionExist);
                  }
                },
                (error: any) => {
                  this.logError(error);
                  this.handleError(error.status);
                },
                () => {
                  if (!this.sessionExist) {
                    this.authService
                      .getAccountDetails(this.baseurl, logincred.username)
                      .subscribe({
                        next: (details) => {},
                        error: (error: any) => {
                          this.logError(error);
                          this.handleError(error.staus);
                        },
                        complete: () => {
                          this.CompleteLoginDetails();
                        },
                      });
                  }
                }
              );
          },
          error: (error: any) => {
            console.log(error);
            this.invalidLoginMessage = error.error.error_description;
            if (
              this.invalidLoginMessage === '' ||
              this.invalidLoginMessage === undefined
            ) {
              this.handleError(error.status);
            } else {
              this.invalidLoginMessage = this.invalidLoginMessage.replace(
                /^"|"$/g,
                ''
              );
            }
          },
        });
    }
  }

  CompleteLoginDetails() {
    this.invalidLoginMessage = '';
    this.authService.currentUserType.subscribe(
      (type: string) => (this.usertype = type)
    );
    this.authService.currentUserToken.subscribe(
      (tk: string) => (this.gotToken = tk !== null)
    );
    this.authService.currentPayorHoldStatus.subscribe(
      (holdstatus: string) =>
        (this.isAccountOnHold =
          holdstatus === null || holdstatus === undefined
            ? false
            : holdstatus === 'true'
            ? true
            : false)
    );
    this.authService.mustChangePassword.subscribe(
      (mcp: string) => (this.mustChangePassword = mcp.toLowerCase() === 'true')
    );

    if (this.isAccountOnHold) {
      this.errorHandlerService.handleErrorMessage(
        SpecialError.AccountHold,
        this.baseurl
      );
    } else if (this.mustChangePassword) {
      this.router.navigate(['changepassword']);
    } else {
      if (
        this.usertype.toLowerCase() === 'ncp' ||
        this.userType.toLowerCase() === 'oth'
      ) {
        this.router.navigate(['ncp/achd/landing']);
      } else if (this.usertype === 'employer') {
        this.router.navigate(['employer/home']);
      }
    }
  }

  goToForgotUsername() {
    this.router.navigateByUrl('forgotusername');
  }

  goToForgotPassword() {
    this.router.navigateByUrl('forgotpassword');
  }

  goToRegistration() {
    this.router.navigateByUrl('register');
  }

  logError(error: Error) {
    this.errorHandlerService.logError(error);
  }

  handleError(error: number) {
    console.log(this.errorMessage);
    this.errorHandlerService.handleErrorMessage(error, this.baseurl);
  }
}

